<template>
  <div class="banner">
    <div id="root" class="root" v-if="bannerList.length" style="overflow: hidden">
      <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white" >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          @click="jumpCourseDetail(index)"
        >
          <img :src="item.images" />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { reqAdvertPlaying } from '@/api/home';
import { gioPlatform, gioJumpType, handleJumpType } from '@/utils/tools';
import { BOOK_MALL_BANNER_AD_CODE } from '../constants/bookMallFilterOptions';

export default {
  name: 'BookMallBannerVant',
  props: {
    /** 可选覆盖默认广告位编码 */
    adCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bannerList: [],
      bannerAdId: '',
      bannerAdName: '',
      lastTime: null,
      gioType: 1,
      gioStop: false,
      showEmpty: true,
    };
  },
  computed: {
    resolvedAdCode() {
      return this.adCode || BOOK_MALL_BANNER_AD_CODE;
    },
  },
  mounted() {
    this.fetchBanner();
  },
  methods: {
    // 与 recommendContent.vue getAd 一致
    async getAd(code) {
      if (!code) return;
      const res = await reqAdvertPlaying([code]);
      const adInfo = res.data?.find((item) => item.adCode === code) || {};
      return adInfo;
    },
    async fetchBanner() {
      try {
        const data = await this.getAd(this.resolvedAdCode);
        this.bannerList = data?.advertisingContentWebInfoRespVOS || [];
        this.bannerAdId = data?.id != null ? String(data.id) : '';
        this.bannerAdName = data?.title != null ? String(data.title) : '';
      } catch (e) {
        this.bannerList = [];
        this.bannerAdId = '';
        this.bannerAdName = '';
      }
    },
    jumpCourseDetail(index) {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent();
      this.lastTime = Date.now();
      handleJumpType(this, this.bannerList[index]);
    },
    gioEvent() {
      gio('track', 'H5adClick_event', {
        adPosition_var: '商城banner',
        courseName_var: '',
        adId_var: this.bannerAdId,
        adName_var: this.bannerAdName,
        platform_var: gioPlatform(),
      });
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.root {
  width: 100% !important;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 16px;
}
.my-swipe {
 width: 678px;
  height: 205px;
  overflow: visible !important;
  border-radius: 8px;
}
::v-deep .van-swipe__track,
::v-deep .van-swipe {
  border-radius: 8px;
}
.my-swipe .van-swipe-item img {
 width: 100%;
  overflow: hidden;
  border-radius: 8px;
  pointer-events: none;
}
::v-deep .van-swipe__indicators .van-swipe__indicator {
  width: 8px;
  height: 5px;
  background: rgba(58, 74, 94, 1);
  border-radius: 4px;
  opacity: 0.3;
}
::v-deep .van-swipe__indicators .van-swipe__indicator--active {
  width: 14px;
  height: 5px;
  background: rgba(58, 74, 94, 1);
  border-radius: 3px;
  opacity: 0.6;
}
</style>
